import i18n from '@/locales'

export const FIELD_TYPES = [
  { id: '0', name: i18n.t('report.field_type.string') },
  { id: '1', name: i18n.t('report.field_type.int') },
  { id: '2', name: i18n.t('report.field_type.float') },
  // { id: '3', name: i18n.t('report.field_type.json') },
  { id: '4', name: i18n.t('report.field_type.date') },
  { id: '5', name: i18n.t('report.field_type.time') },
  { id: '6', name: i18n.t('report.field_type.enume') },
]

export const SERVE_FIELDS = ['ServiceProcurementTime', 'ServiceStartTime', 'ServiceEndTime', 'ServicePricePerYear']
export const ASSET_FIELDS = ['ProcurementDate', 'DepreciationLife', 'ProcurementAmount']

const field_name_blacklist = ['ID', '创建时间', 'Created At', '作成時間'];

([...SERVE_FIELDS, ...ASSET_FIELDS]).map(key => {
  field_name_blacklist.push(i18n.t(`report.bill_fields.${key}`))
})

export const FIELD_NAME_BLACKLIST = field_name_blacklist

export const getFieldValueTypeText = (row) => {
  if (row.value_type === 0 && row.choices && row.choices.length) {
    return i18n.t('report.field_type.enume')
  }
  const target = FIELD_TYPES.filter(item => Number(item.id) === row.value_type)
  return target[0] ? target[0].name : '-'
}

export const getFieldConfigText = (row) => {
  const ret = []
  if (row.is_required) {
    ret.push(i18n.t('report.field_setting_is_required'))
  }
  if (row.is_uniq) {
    ret.push(i18n.t('report.field_setting.unique'))
  }
  if (row.value_type === 1 || row.value_type === 2) {
    // if (row.min !== null && row.min !== undefined && row.max !== null && row.max !== undefined) {
    //   ret.push(`${row.min}~${row.max}`)
    // } else if (row.min !== null && row.min !== undefined) {
    //   ret.push(`${row.min}`)
    // } else if (row.max !== null && row.max !== undefined) {
    //   ret.push(`${row.max}`)
    // }
    if (row.min && row.max && row.min <= row.max) {
      ret.push(`${row.min}~${row.max}`)
    }
  }
  if (row.value_type === 0 && row.choices && row.choices.length) {
    return i18n.t('report.field_enume.values', [row.choices.join('、')])
  }
  return ret.join(' ')
}
